import Link from "next/link";
import { useRouter } from "next/router";

import { twMerge } from "tailwind-merge";

const Paginator = ({ totalPages }: { totalPages: number }) => {
  const router = useRouter();
  const page = router.query.page && parseInt(router.query.page as string);

  if (!page) return null;

  return (
    <nav
      className={twMerge(
        "flex justify-between",
        "px-[30px] py-[10px]",
        "text-smart-teal"
      )}
    >
      <div className="space-x-[10px]">
        {page > 2 && (
          <Link
            href={{
              pathname: router.pathname,
              query: { ...(router.query || {}), page: 1 },
            }}
            className="cursor-pointer"
          >
            First
          </Link>
        )}
        {page > 1 && (
          <Link
            href={{
              pathname: router.pathname,
              query: { ...(router.query || {}), page: page - 1 },
            }}
            className="cursor-pointer"
          >
            Previous
          </Link>
        )}
      </div>
      <div className="space-x-[10px]">
        {[-3, -2, -1, 0, 1, 2, 3].map((offset) => {
          if (page + offset <= 0 || page + offset > totalPages) return null;

          return (
            <Link
              key={offset}
              href={{
                pathname: router.pathname,
                query: { ...(router.query || {}), page: page + offset },
              }}
              className={twMerge(
                offset ? "cursor-pointer" : "cursor-none font-bold"
              )}
            >
              {page + offset}
            </Link>
          );
        })}
      </div>
      <div className="space-x-[10px]">
        {totalPages > page && (
          <Link
            href={{
              pathname: router.pathname,
              query: { ...(router.query || {}), page: page + 1 },
            }}
            className="cursor-pointer"
          >
            Next
          </Link>
        )}
        {totalPages > page + 1 && (
          <Link
            href={{
              pathname: router.pathname,
              query: { ...(router.query || {}), page: totalPages },
            }}
            className="cursor-pointer"
          >
            Last
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Paginator;
